import { render, staticRenderFns } from "./ReceiptsTable.vue?vue&type=template&id=54ce6c71&scoped=true&lang=pug&"
import script from "./ReceiptsTable.vue?vue&type=script&lang=js&"
export * from "./ReceiptsTable.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptsTable.vue?vue&type=style&index=0&id=54ce6c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ce6c71",
  null
  
)

export default component.exports